import { render, staticRenderFns } from "./zongSou.vue?vue&type=template&id=11e7c434"
import script from "./zongSou.vue?vue&type=script&lang=js"
export * from "./zongSou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports